<template>
   <!--get 接口测试 -->
  <div id="testget">
    <h1>get 接口</h1>
    <button v-on:click="testbtn()">测试</button>
    <button v-on:click="bannerA()">获得banner</button>
    {{this.$store.state.period}}
    <button v-on:click="change()">加加加</button>
    <button v-on:click="reduce()">减减减</button>
    {{this.$store.getters.getStateSubject}}
    {{this.$store.getters.getStatePeriod}}
  </div>
</template>

<script>
import axios from 'axios'
import {encryption} from '../../assets/js/encryption.js' // 请求必需携带公共头部
export default {
  name: 'testGet',
  methods: {
    testbtn () {
      // this.$http.get("https://getman.cn/echo")
      //   .then(function(response){
      //     alert(response)
      //   })
      // developer: '22307e52eb1895b809031eba30900f80'
      // type: 1
      // phone: 15210232624   id
      // time: time() = Math.round(new Date().getTime()/1000-28800)
      // $.ksort()
      // data: 'phone=15210232624&type=1'    //ksort($data) ;  // $str .= $k.'='.$v.'&' ;
      // $str:  'phone=15210232624&type=122307e52eb1895b809031eba30900f80'       //$str = trim($str,'&') ;$str.= $developer ; //一层次加密 主键排序 拼接成字符串 key=val&key=val&...&开发者身份id 使用 sha1 加密后转化成大写
      // $sign_sha1: ''     // $sign_sha1 = strtoupper(sha1($str)) ;
      // md5: $sign_md5 = md5($developer.$sign_sha1.$time) ;     // 二层加密 开发者身份id . 加密后的sign .当前时间戳  MD5 再次加密

      /**
       * 测试参数：
       * @type {string}
       */
      // let sha = sha1('123456').toUpperCase()
      // let sha2 = md5('123456')

      /**
       * sign: 取得方法，需要用到 请求对象data，develop预设值，time时间戳
       * 1.params: 获得需要提交的data对象
       * 2.对象按字典顺序排序并生成字串
       * 3.对生成字串进行sha1加密，并转成大写
       * 4.全大写字串：拼装上developer和time，后进行md5加密
       * 5.生成的md5值与/、develop、time、test拼接成sign值
       */
      // let developer = '22307e52eb1895b809031eba30900f80'
      // 获得时间戳
      // let time = Math.round(new Date().getTime() / 1000)
      // let str = 'phone=15210232624&type=122307e52eb1895b809031eba30900f80'
      // let signSha1 = sha1(str).toUpperCase()
      // alert(signSha1)
      // let signMd5 = md5(developer + signSha1 + time)
      // let sign = signMd5 + '/' + developer + '/' + time + '/test'
      // alert(sign)

      let data = {
        phone: '15210232624',
        type: '1'
      }

      // alert(encryption(params))
      // return false
      axios({
        method: 'GET',
        url: '/api/app/v1/get_phone_code',
        params: data,
        headers: {
          // 'sign': sign
          'sign': encryption(data)
        }
      })
        .then(res => { console.log(res); alert(res.data) })
        .catch(err => { console.log(err) })
    },
    encryption () {
      // let developer = '22307e52eb1895b809031eba30900f80'
      // 获得时间戳
      // let time = Math.round(new Date().getTime() / 1000)
    },
    bannerA () {
      let data = {
        type: '1',
        page: 1,
        subject: 1,
        period: 1
      }
      // let kData = ksort(data)
      // alert(QS.stringify(kData))
      // console.log(kData)
      // console.log(QS.stringify(kData))
      let sign = encryption(data)
      alert(sign)
      console.log(sign)
      axios({
        method: 'GET',
        url: '/api/app/v1/get_home_banner',
        params: data,
        headers: {
          'sign': sign
        }
      })
        .then(res => { console.log(res); alert(res.data) })
        .catch(err => { console.log(err) })
    },
    change () {
      // this.$store.state.period = 8
      // this.$store.commit('alterStateSubject', 10)
      this.$store.dispatch('alterSubject', 10)
      // this.$store.commit('add');
    },
    reduce () {
      // this.$store.commit('reduction')
      this.$store.commit('decrement')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/test/testGet.vue